<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <div class="card-body">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <toggleswitch
            :labels="true"
            name="using_own"
            v-model="form.using_own"
            label="Using Clients Own Insurance?"
          ></toggleswitch>

          <selectlist
            :options="insurers"
            v-model="form.insurer_id"
            label="Insurer"
            label-name="name"
            placeholder="Please Select"
            name="insurer"
            :show-error="form.errors.has('insurer')"
          ></selectlist>

          <inputbox
            v-model="form.policy"
            name="policy"
            label="Policy Number"
            :show-error="form.errors.has('policy')"
          ></inputbox>

          <selectlist
            :options="coverLevels"
            v-model="form.cover_level_id"
            label="Cover Level"
            placeholder="Please Select"
            name="cover_level"
            :show-error="form.errors.has('cover_level_id')"
          ></selectlist>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <form-button :indicator="form.processing()" v-on:clicked="submit"
        >Save</form-button
      >
    </div>
  </form>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      client: null,
      insurers: [],
      coverLevels: [],
      form: new window.Form(
        {
          using_own: false,
          insurer_id: '',
          policy: null,
          cover_level_id: ''
        },
        false
      ),
      data_entered: false
    };
  },

  mounted() {
    this.mount();
  },

  methods: {
    mount() {
      window.Ajax.get('/incidents/' + this.incident + '/client')
        .then(response => {
          this.client = response.data.identifier;

          window.Ajax.get('/insurers')
            .then(response => {
              this.insurers = response.data;
            })
            .catch(error => {});

          window.Ajax.get('/cover-levels')
            .then(response => {
              this.coverLevels = response.data;
            })
            .catch(error => {});

          window.Ajax.get(
            '/incidents/' +
              this.incident +
              '/client/' +
              this.client +
              '/insurance'
          )
            .then(response => {
              this.form.using_own = response.data.using_own;
              this.form.insurer_id = response.data.insurer_id;
              this.form.policy = response.data.policy;
              this.form.cover_level_id = response.data.cover_level_id;
            })
            .catch(error => {});
        })
        .catch(error => {});
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    submit() {
      window.toastify.info('Saving', "We're saving those details for you.");

      this.form
        .post(
          '/incidents/' +
            this.incident +
            '/client/' +
            this.client +
            '/insurance'
        )
        .then(response => {
          window.toastify.success(
            'Saved',
            "We've updated those details for you."
          );
          // reset monitoring of form changes
          this.data_entered = false;
          this.$emit('unsaved-data', this.data_entered);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the insurance details.'
          );
        });
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
